import React, { useState } from "react";
import HrnbModal from "./../controls/HrnbModal";
import HrnbCard from "./../controls/HrnbCard";
import HrnbFormControl from "./../controls/HrnbFormControl";
import HrnbButton from "./../controls/HrnbButton";
import {SendIcon} from "../../icons";


export default function MessagePopup({ isOpen, onClose, profile, onSendMessage, sending }) {
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = () => {
        if (!profile) {
            setError("Выберите получателя");
            return;
        }
        if (!message.trim()) {
            setError("Введите сообщение");
            return;
        }

        onSendMessage({ profile, message });
        if (!sending) handleClose();
    };

    const handleClose = () => {
        setMessage("");
        setError("");
        onClose();
    };

    if (!isOpen) return null;


    return (
        <HrnbModal open={isOpen} onClose={handleClose} style={{ zIndex: 9999}}>
            <HrnbCard title={profile.displayName}>
                <div className="hrnb-message-popup__body">
                    {error && (
                        <div className="hrnb-message-popup__error">
                            {error}
                        </div>
                    )}

                    <HrnbFormControl
                        as="textarea"
                        value={message}
                        onChange={(e) => setMessage(e.target.value)}
                        placeholder="Введите ваше сообщение..."
                        rows={4}
                        className="hrnb-message-popup__form-control"
                    />

                </div>

                <div className="hrnb-message-popup__footer">
                    <HrnbButton variant="primary" onClick={handleSubmit} icon={<SendIcon />} disabled={sending}>
                        {sending ? "Отправка..." : "Отправить"}
                    </HrnbButton>
                </div>
            </HrnbCard>
        </HrnbModal>
    );
}